var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "d-flex justify-between" }, [
      _c(
        "a",
        {
          staticClass: "mdc-button mdc-button--outlined me-2",
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.goBack.apply(null, arguments)
            },
          },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("west")])]
      ),
    ]),
    _vm._v(" "),
    _c("h1", { staticClass: "mt-2" }, [_vm._v("アカウント退会")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.showConfirmation.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "password" } }, [
            _vm._v("現在のパスワード"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password",
              },
            ],
            attrs: {
              type: "password",
              id: "password",
              required: "",
              placeholder: "退会確認のため、現在のパスワードを入力してください",
            },
            domProps: { value: _vm.password },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.password = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _vm.passwordError
            ? _c("div", { staticClass: "error-message" }, [
                _vm._v("\n        " + _vm._s(_vm.passwordError) + "\n      "),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkbox-group" }, [
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.confirmDelete,
                  expression: "confirmDelete",
                },
              ],
              attrs: { type: "checkbox", required: "" },
              domProps: {
                checked: Array.isArray(_vm.confirmDelete)
                  ? _vm._i(_vm.confirmDelete, null) > -1
                  : _vm.confirmDelete,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.confirmDelete,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.confirmDelete = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.confirmDelete = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.confirmDelete = $$c
                  }
                },
              },
            }),
            _vm._v(
              "\n        退会するとすべてのデータが削除され、復元できないことを理解しました\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "checkbox-group" }, [
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.confirmReason,
                  expression: "confirmReason",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.confirmReason)
                  ? _vm._i(_vm.confirmReason, null) > -1
                  : _vm.confirmReason,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.confirmReason,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.confirmReason = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.confirmReason = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.confirmReason = $$c
                  }
                },
              },
            }),
            _vm._v(
              "\n        退会理由を教えていただけると、サービス改善の参考にさせていただきます（任意）\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.confirmReason
          ? _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "reason" } }, [_vm._v("退会理由")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.reason,
                      expression: "reason",
                    },
                  ],
                  attrs: { id: "reason" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.reason = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("選択してください"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "1" } }, [
                    _vm._v("使用頻度が少ない"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "2" } }, [
                    _vm._v("他のサービスに乗り換える"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "3" } }, [
                    _vm._v("期待していた内容と違った"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "4" } }, [
                    _vm._v("料金が高い"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "5" } }, [
                    _vm._v("使いにくい"),
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "6" } }, [_vm._v("その他")]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.reason === "6"
          ? _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "otherReason" } }, [
                _vm._v("その他の理由"),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.otherReason,
                    expression: "otherReason",
                  },
                ],
                attrs: {
                  id: "otherReason",
                  placeholder: "退会理由を詳しく教えてください",
                },
                domProps: { value: _vm.otherReason },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.otherReason = $event.target.value
                  },
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "btn-group" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button" },
              on: { click: _vm.redirectToMyProfile },
            },
            [_vm._v("キャンセル")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger",
              attrs: { type: "submit", disabled: !_vm.confirmDelete },
            },
            [_vm._v("退会手続きへ進む")]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.showConfirmModal
      ? _c("div", { staticClass: "modal-backdrop" }, [
          _c("div", { staticClass: "modal" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  on: {
                    click: function ($event) {
                      _vm.showConfirmModal = false
                    },
                  },
                },
                [_vm._v("キャンセル")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  on: { click: _vm.deleteAccount },
                },
                [_vm._v("削除する")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.processing
      ? _c("div", { staticClass: "modal-backdrop" }, [_vm._m(3)])
      : _vm._e(),
    _vm._v(" "),
    _vm.showSuccessModal
      ? _c("div", { staticClass: "modal-backdrop" }, [
          _c("div", { staticClass: "modal" }, [
            _vm._m(4),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  on: { click: _vm.redirectToHome },
                },
                [_vm._v("トップページへ")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showErrorModal
      ? _c("div", { staticClass: "modal-backdrop" }, [
          _c("div", { staticClass: "modal" }, [
            _vm._m(6),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("p", [_vm._v(_vm._s(_vm.errorMessage))]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "問題が解決しない場合は、サポートまでお問い合わせください。"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  on: {
                    click: function ($event) {
                      _vm.showErrorModal = false
                    },
                  },
                },
                [_vm._v("閉じる")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-warning" }, [
      _c("p", [
        _c("i", { staticClass: "fas fa-exclamation-triangle icon-warning" }),
        _vm._v(
          " 退会すると、以下のデータが完全に削除され、復元できなくなります：\n    "
        ),
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [_vm._v("学習履歴やテスト結果")]),
        _vm._v(" "),
        _c("li", [_vm._v("購入したコースへのアクセス権")]),
        _vm._v(" "),
        _c("li", [_vm._v("保存された学習進捗状況")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h2", [
        _c("i", { staticClass: "fas fa-exclamation-triangle icon-warning" }),
        _vm._v(" 最終確認"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", [
        _vm._v("本当にアカウントを削除しますか？この操作は取り消せません。"),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("strong", [
          _vm._v(
            "すべての学習データ、テスト結果、およびコース進捗状況が完全に削除されます。"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "processing-overlay" }, [
      _c("div", { staticClass: "spinner" }),
      _vm._v(" "),
      _c("p", [_vm._v("処理中です。しばらくお待ちください...")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h2", { staticStyle: { color: "#2ecc71" } }, [
        _c("i", { staticClass: "fas fa-check-circle" }),
        _vm._v(" 退会手続き完了"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", [
        _vm._v(
          "アカウント削除が完了しました。ご利用いただきありがとうございました。"
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("またのご利用をお待ちしております。")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h2", [
        _c("i", { staticClass: "fas fa-exclamation-circle icon-warning" }),
        _vm._v(" エラー"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }